import { DifferenceResult } from "../@types/ChangeLog";

// Helper to identify plain objects (excluding null, arrays, dates, etc.)
function isPlainObject(item: any): item is Record<string, any> {

    return item && typeof item === 'object' && !Array.isArray(item);

}

const getObjectDifferences = <T extends Record<string, any>>(object1: T, object2: T): DifferenceResult => {

    // Guard clause if both are not objects
    if (!isPlainObject(object1) || !isPlainObject(object2)) {

        return object1 !== object2 ? { oldValue: object1, newValue: object2 } : {};

    }

    const differences: DifferenceResult = {};

    // Gather all unique keys from both objects
    const allKeys = new Set([...Object.keys(object1), ...Object.keys(object2)]);

    for (const key of allKeys) {

        const val1 = object1[key];

        const val2 = object2[key];

        // Case 1: Key exists in one but not the other, or type has changed completely
        if (!(key in object1) || !(key in object2)) {

            if (val1 !== val2) {

                differences[key] = { oldValue: val1, newValue: val2 };

            }

            continue;

        }

        // Case 2: Both values are nested objects -> Recurse deeper
        if (isPlainObject(val1) && isPlainObject(val2)) {

            const nestedDiff = getObjectDifferences(val1, val2);

            // Only add to the final diff if the nested object actually contains differences
            if (Object.keys(nestedDiff).length > 0) {

                differences[key] = nestedDiff;

            }

        }

        // Case 3: Primitive values or Arrays -> Direct comparison
        else if (JSON.stringify(val1) !== JSON.stringify(val2)) {

            differences[key] = { oldValue: val1, newValue: val2 };

        }

    }

    return differences;

}


export default getObjectDifferences;